import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionRoute, type PermissionRouteData } from '@exam-center/router';

interface AdminExamCenterDetailsPermissionRouteProps {
  examCenterCode: string;
}

export default function AdminExamCenterDetailsPermissionRoute(
  props: Readonly<AdminExamCenterDetailsPermissionRouteProps>,
) {
  const { examCenterCode } = props;

  const routes: PermissionRouteData[] = [
    {
      path: '/admin/exam-centers/:examCenterCode/details',
      params: { examCenterCode },
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW],
    },
    {
      path: '/admin/exam-centers/:examCenterCode/details/members',
      params: { examCenterCode },
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.VIEW],
    },
    {
      path: '/admin/exam-centers/:examCenterCode/details/exam-courses',
      params: { examCenterCode },
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW],
    },
  ];

  return <PermissionRoute routes={routes} />;
}
